import { config } from '@/pageConfig/sitemap/nl/nl';
import { SitemapPageTemplate } from '@/pageTemplate/SitemapPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function SitemapPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(() => trackEvent('sitemap_page.viewed'), []);

  return <SitemapPageTemplate config={config} />;
}
